<template>
    <div @click="openForm" class="media-wrapper lozad">
        <img class="lozad" :data-src="src" :alt="title">
        <div class="skeleton"></div>
    </div>
</template>

<script>
export default {
    name: 'ImgOpenIframe',
    props: {
        src: {
            type: String,
            default: ''
        },
        tags: {
            type: Array,
            default: () => [],
        },
        title: {
            type: String,
            default: ''
        },
        description: {
            type: String,
            default: ''
        },
        link: {
            type: String,
            default: ''
        },
        year: {
            type: String,
            default: ''
        }
    },
    methods: {
        openForm() {
            this.$store.commit('toggleModalIframeShow');
            this.$store.commit('setActiveIframe', {
                title: this.title,
                description: this.description,
                link: this.link,
                year: this.year,
                tags: this.tags,
            });
        }
    },
}

</script>

